export default __webpack_public_path__ + "static/batchimage-96056b0372a5efd24ea5352b7da5d1a4.png";